import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import * as Diff2Html from 'diff2html';
import { withTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import AppModal from '../../../components/Modal';
export const withAutoFixSuggestionsModal = (WrappedComponent) => withTranslation()(class AutoFixSuggestionsModal extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
            diff: '',
        };
        this.handleCloseModal = () => {
            this.setState({ open: false });
        };
        this.handleClick = (diff) => {
            this.setState({
                open: true,
                diff,
            });
        };
    }
    renderModal() {
        const { diff } = this.state;
        const { t } = this.props;
        // @todo: Verify if we don't need all the commented type incompatible properties.
        const config = {
            //inputFormat: 'json',
            drawFileList: false,
            //fileListToggle: false,
            //fileListStartVisible: false,
            //fileContentToggle: false,
            matching: 'lines',
            outputFormat: 'line-by-line',
            //synchronisedScroll: true,
            //highlight: true,
            renderNothingWhenEmpty: false,
            maxLineSizeInBlockForComparison: 100,
        };
        const outputHtml = Diff2Html.html(diff, config);
        return (_jsxs(Modal, { isOpen: true, toggle: this.handleCloseModal, autoFocus: false, size: "xl", children: [_jsx(ModalHeader, { toggle: this.handleCloseModal, children: t('autoFixesTitle') }), _jsx(ModalBody, { children: _jsx("div", { id: "code-diff", dangerouslySetInnerHTML: { __html: outputHtml } }) })] }));
    }
    render() {
        return (_jsxs("div", { children: [_jsx(WrappedComponent, { ...this.props, showAutoFixesClick: this.handleClick }), this.state.open && _jsx(AppModal, { children: this.renderModal() })] }));
    }
});
